/*
 * Public API Surface of storage
 */


export * from './lib/storage.service';
export * from './lib/storageModelPermType';
export * from './lib/storage.component';
export * from './lib/storage.module';
